import { AppDispatch, persistor } from "../store";
import { logout } from "../store/slices/authSlice";

const LOGOUT_IN_PROGRESS_KEY = "oidc_logout_in_progress_at";
const LOGOUT_IN_PROGRESS_TTL_MS = 2 * 60 * 1000;

export const logoutAndClearStorage = () => (dispatch: AppDispatch) => {
  dispatch(logout());
  persistor.purge();
};

export const setLogoutInProgress = () => {
  sessionStorage.setItem(LOGOUT_IN_PROGRESS_KEY, String(Date.now()));
};

export const clearLogoutInProgress = () => {
  sessionStorage.removeItem(LOGOUT_IN_PROGRESS_KEY);
};

export const isLogoutInProgress = () => {
  const raw = sessionStorage.getItem(LOGOUT_IN_PROGRESS_KEY);
  if (!raw) {
    return false;
  }

  const startedAt = Number(raw);
  if (!Number.isFinite(startedAt)) {
    clearLogoutInProgress();
    return false;
  }

  if (Date.now() - startedAt > LOGOUT_IN_PROGRESS_TTL_MS) {
    clearLogoutInProgress();
    return false;
  }

  return true;
};

export const getUserInitials = (name?: string) => {
  if (!name) return "U";

  if (name.includes(".")) {
    const [firstName, lastName] = name.split(".");
    return (firstName[0] + lastName[0]).toUpperCase();
  }

  const names = name.split(" ");
  if (names.length >= 2) {
    return (names[0][0] + names[1][0]).toUpperCase();
  }

  return name.slice(0, 2).toUpperCase();
};
